import { useEffect, useState } from 'react';
import axios from 'axios';
import { CreditCard, CheckCircle2, AlertCircle } from 'lucide-react';
import { DASH, authHeader } from '../api';
import { SectionCard, Spinner, Badge, fmtDate } from '../ui';

const SettingsSection = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${DASH}/settings/stripe-status`, { headers: authHeader() })
      .then((res) => mounted && setStatus(res.data))
      .catch(() => mounted && setError('Could not load Stripe status.'))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return <Spinner label="Loading settings…" />;

  return (
    <div data-testid="wellness-admin-section-settings" className="space-y-4">
      <div>
        <h2 className="text-2xl tracking-tight" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#0d1f15' }}>
          Settings
        </h2>
        <p className="text-sm text-[#5a7062] mt-1">Payment connection status.</p>
      </div>
      {error && <div className="text-sm text-red-700">{error}</div>}
      {status && (
        <SectionCard title="Stripe Connection" testId="stripe-status-card">
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${status.connected ? 'bg-green-100' : 'bg-red-100'}`}>
              {status.connected ? <CheckCircle2 size={18} className="text-green-600" /> : <AlertCircle size={18} className="text-red-600" />}
            </div>
            <div>
              <div className="font-semibold text-[#0d1f15]" data-testid="stripe-connected-label">
                {status.connected ? 'Connected' : 'Not connected'}
              </div>
              <div className="text-xs text-[#5a7062]">Key: {status.masked_key}</div>
            </div>
            <Badge tone={status.mode === 'live' ? 'gold' : 'gray'}>{status.mode} mode</Badge>
          </div>
          <div className="flex items-center gap-2 text-sm text-[#5a7062] border-t border-[#f0ebe0] pt-4">
            <CreditCard size={14} />
            Last webhook event: {status.last_webhook_event_at ? `${fmtDate(status.last_webhook_event_at)} (${status.last_webhook_status})` : 'none yet'}
          </div>
          <p className="text-xs text-[#9aa69e] mt-4">
            To rotate the Stripe secret key, update <code>STRIPE_API_KEY</code> in the backend environment — key entry is intentionally not exposed in this UI for security.
          </p>
        </SectionCard>
      )}
    </div>
  );
};

export default SettingsSection;
